import { render, staticRenderFns } from "./TemplateOrderDetail.vue?vue&type=template&id=7bbff944&scoped=true"
import script from "./TemplateOrderDetail.vue?vue&type=script&lang=js"
export * from "./TemplateOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbff944",
  null
  
)

export default component.exports